import { render, staticRenderFns } from "./RankChangeForm.vue?vue&type=template&id=4131f4b8&scoped=true&"
import script from "./RankChangeForm.vue?vue&type=script&lang=js&"
export * from "./RankChangeForm.vue?vue&type=script&lang=js&"
import style0 from "./RankChangeForm.vue?vue&type=style&index=0&id=4131f4b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4131f4b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCol,VDialog,VIcon,VRow})
